import React, { useContext } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import useStyles from "./styles.js";
import { WebContext } from "../../../../../Utility.js";
import { StyledTextButton } from "../../../Commons/styledButton.js";
import defaultDestination from "../../../../../assets/images/defaultDestination.jpg";
import { useTheme } from "@material-ui/core/styles";

const Component3 = () => {
  const theme = useTheme();
  const websiteData = useContext(WebContext);
  const classes = useStyles();
  let { destinations = [], username = "", deskTopView = true } = websiteData;
  destinations =
    destinations && destinations.length > 4
      ? destinations.slice(0, 4)
      : destinations;

  const handleRedirect = () => {
    window.location.href = `/${username ? `${username}/` : ""}destinations`;
  };

  if (!destinations || destinations.length === 0) return null;

  return (
    <Container
      className={`${classes.mainContainer} ${classes.indexMainContainer}`}
      id="destinations"
    >
      <Typography variant="h2" className={classes.headerText} align="center">
        Go Exotic Places
      </Typography>

      <Typography
        variant="body1"
        style={{
          fontSize: deskTopView ? 20 : 16,
          marginBottom: !deskTopView ? 0 : undefined,
          color: theme.agentTheme.background.primary_text,
        }}
        className={classes.otherText}
        align="center"
      >
        A journey of a 1000 miles starts with a single step.
      </Typography>

      <Box
        className={`${classes.destinationGridContainer} ${
          classes[`gridLayout${destinations.length}`]
        }`}
      >
        {destinations.map((item, index) => {
          let { name = "", destination_detail } = item || {};
          let { image = "" } = destination_detail || {};

          return (
            <Box
              key={index}
              className={classes[`gridItem${index + 1}`]}
              mt={!deskTopView ? 2 : 0}
            >
              <a
                href={
                  username
                    ? `/${username}/packages?&destination=${name}&isDestinationPage=true`
                    : `/packages?&destination=${name}&isDestinationPage=true`
                }
                style={{ width: "100%" }}
              >
                <div className={`imgWrapper ${classes.imgContainer}`}>
                  <img
                    src={image || defaultDestination}
                    alt={name}
                    className={classes.imageProps}
                  />
                </div>

                <div className={classes.bgVideoOverlayContainer}>
                  <Typography
                    style={{
                      fontWeight: deskTopView ? 500 : 400,
                      fontSize: deskTopView ? "32px" : "24px",
                    }}
                  >
                    {name}
                  </Typography>
                </div>
              </a>
            </Box>
          );
        })}
      </Box>

      <div>
        <StyledTextButton
          className={classes.bannerTextBtn}
          buttonText="VIEW ALL"
          buttonRedirect={handleRedirect}
        />
      </div>
    </Container>
  );
};

export default Component3;
